const JobListdata = [
    {
        id: 1,
        title: "Magento Developer",
        name: "Themesbrand",
        location: "California",
        experience: "0-2 Years",
        position: 2,
        type: "Full Time",
        type_color: "success",
        posted_date: "02 June 2021",
        last_date: "25 June 2021",
        status: "Active",
        status_color: "success"
    },
    {
        id: 2,
        title: "Product Designer",
        name: "Web Technology pvt.ltd",
        location: "California",
        experience: "1-2 Years",
        position: 3,
        type: "Part Time",
        type_color: "danger",
        posted_date: "15 June 2021",
        last_date: "28 June 2021",
        status: "New",
        status_color: "info"
    },
    {
        id: 3,
        title: "Marketing Director",
        name: "Creative Agency",
        location: "Phoenix",
        experience: "-",
        position: 5,
        type: "Full Time",
        type_color: "success",
        posted_date: "02 June 2021",
        last_date: "25 June 2021",
        status: "Close",
        status_color: "danger"
    },
    {
        id: 4,
        title: "HTML Developer",
        name: "Web Technology pvt.ltd",
        location: "California",
        experience: "0-4 Years",
        position: 8,
        type: "Full Time",
        type_color: "success",
        posted_date: "02 June 2021",
        last_date: "25 June 2021",
        status: "Active",
        status_color: "success"
    },
    {
        id: 5,
        title: "Product Sales Specialist",
        name: "Skote Technology pvt.Ltd",
        location: "Louisiana",
        experience: "5+ Years",
        position: 1,
        type: "Part Time",
        type_color: "danger",
        posted_date: "02 June 2021",
        last_date: "25 June 2021",
        status: "New",
        status_color: "info"
    },
    {
        id: 6,
        title: "Magento Developer",
        name: "New Technology pvt.ltd",
        location: "Oakridge Lane Richardson",
        experience: "0-2 Years",
        position: 2,
        type: "Freelance",
        type_color: "info",
        posted_date: "02 June 2021",
        last_date: "25 June 2021",
        status: "New",
        status_color: "info"
    },
    {
        id: 7,
        title: "Business Associate",
        name: "Web Technology pvt.ltd",
        location: "California",
        experience: "0-2 Years",
        position: 2,
        type: "Full Time",
        type_color: "success",
        posted_date: "02 June 2021",
        last_date: "25 June 2021",
        status: "Active",
        status_color: "success"
    },
    {
        id: 8,
        title: "Magento Developer",
        name: "Adobe Agency",
        location: "California",
        experience: "0-2 Years",
        position: 2,
        type: "Full Time",
        type_color: "success",
        posted_date: "02 June 2021",
        last_date: "25 June 2021",
        status: "Close",
        status_color: "danger"
    },
    {
        id: 9,
        title: "HTML Developer",
        name: "Web Technology pvt.ltd",
        location: "California",
        experience: "0-2 Years",
        position: 2,
        type: "Part Time",
        type_color: "danger",
        posted_date: "02 June 2021",
        last_date: "25 June 2021",
        status: "New",
        status_color: "info"
    },
    {
        id: 10,
        title: "Marketing Director",
        name: "Web Technology pvt.ltd",
        location: "California",
        experience: "0-2 Years",
        position: 2,
        type: "Internship",
        type_color: "warning",
        posted_date: "02 June 2021",
        last_date: "25 June 2021",
        status: "Active",
        status_color: "success"
    },
    {
        id: 11,
        title: "Marketing Director",
        name: "Web Technology pvt.ltd",
        location: "California",
        experience: "0-2 Years",
        position: 2,
        type: "Internship",
        type_color: "warning",
        posted_date: "02 June 2021",
        last_date: "25 June 2021",
        status: "Active",
        status_color: "success"
    },
    {
        id: 12,
        title: "Marketing Director",
        name: "Web Technology pvt.ltd",
        location: "California",
        experience: "0-2 Years",
        position: 2,
        type: "Internship",
        type_color: "warning",
        posted_date: "02 June 2021",
        last_date: "25 June 2021",
        status: "Active",
        status_color: "success"
    },
];

export { JobListdata };
